<template>
    <v-card tile>
            <v-card-title>ข้อมูลจบงานเลขที่: {{withdrawData.closeJobNo}}</v-card-title>
            <v-divider></v-divider>
    
    <v-container> 
            <v-data-table
            
            :headers="headers"
            :items="items"
            item-key="invoiceNo"
            
            class="elevation-1"
            >
        </v-data-table>

         <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="close"
          >
            CLOSE
          </v-btn>
        </v-card-actions>

    </v-container>
    </v-card>
</template>

<script>
// import {listItemByCloseJobNo} from '@/api/accounting/withdraw-api.js'
import numeral from 'numeral'
export default {
    props: ["withdrawData"],
    data: () => ({
         rules: {
            required: value => !!value || 'Required.'
        },
        headers: [
            {text: "วันที่ใบแจ้งหนี้", value: "strInvoiceDate"},
            {text: "ทะเบียน", value: "licenseNo"},
            {text: "เลขที่ใบสั่งซ่อม", value: "jobNo"},
            {text: "เลขที่ใบประเมิน", value: "estimateNo"},
            {text: "เลขที่ใบแจ้งหนี้", value: "invoiceNo"},
            {text: "ยอดสุทธิ", value: "invoiceAmountDisplay"},
            {text: "ยอดเบิก", value: "grandWdTotalDisplay"},
            {text: "จ่ายจริง", value: "actualReceiptsDisplay"},
            {text: "% เบิก", value: "percentWithdraw"},
            {text: "หมายเหตุ", value: "remark"}
        ],
        items:[]
    }),
    methods: {
        setItems(items){
            this.items = Object.assign([], items);
            if (this.items) {
                this.items.forEach((e) => {
                    e.invoiceAmountDisplay = numeral(e.invoiceAmount).format('0,0.00');
                    e.grandWdTotalDisplay = numeral(e.grandWdTotal).format('0,0.00');
                     e.actualReceiptsDisplay = numeral(e.actualReceipts).format('0,0.00');
                });
            }
        },
        close() {
            this.items = Object.assign([], []);
            this.$emit("closeViewDialog");
        }
    }
}
</script>